module.exports = __webpack_public_path__ + "img/icon-flora.86a4ea09.svg";